/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { Action } from '../../../../components/ActionsCard/ActionCard';
import { strings } from '../../../../intl/Strings';
import { logger } from '../../../../shared';
import { TrialActionId } from '../shared';

export const WordTryCopilotActionCard = (showSecondary: boolean = true): Action => ({
    id: TrialActionId.TryCopilotDialog,
    checked: false,
    primaryContent: strings.getString('trialconversionWordTryCopilotDialogHeader'),
    secondaryContent: strings.getString('trialconversionWordTryCopilotDialogContent'),
    showSecondaryContent: showSecondary,
    onClick: () => logger.logInfo('TrialConversionWordCard', 'Try Copilot clicked'),
    retriggerable: true
});
